import { parsePath, routePaths } from 'utils/routes';

/**
 * The stored home page, when it is a safe in-app path (path + query + hash). It is not checked against
 * the routes: a page that no longer works should show its error so the user can clear it, not be
 * silently skipped.
 */
export function getStoredHomePage(homePage: string | undefined): string | undefined {
  // a second "/" or "\\" makes it a link to another host, not a path in this app
  if (!homePage || !homePage.startsWith('/') || /^\/[/\\]/.test(homePage)) {
    return undefined;
  }
  // "/" only redirects to the landing page, so using it as the destination would redirect to itself
  if (homePage.split(/[?#]/)[0] === routePaths.home) {
    return undefined;
  }
  return homePage;
}

/** Whether a page can be saved as the home page: a known route in this tenant. */
export function canSetAsHomePage(page: string, tenantSlug: string): boolean {
  if (!getStoredHomePage(page)) {
    return false;
  }
  const { routePath, tenantSlug: pageTenantSlug } = parsePath(page.split(/[?#]/)[0]);
  return !!routePath && !(routePath.startsWith('/:tenant/') && pageTenantSlug !== tenantSlug);
}
